export const MOCK_TRACK_SQ247 = [
  {
    fa_flight_id: null,
    altitude: 3,
    altitude_change: 'C',
    groundspeed: 166,
    heading: 24,
    latitude: 1.3509,
    longitude: 103.99445,
    timestamp: '2025-02-26T11:33:54Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 10,
    altitude_change: 'C',
    groundspeed: 159,
    heading: 23,
    latitude: 1.36207,
    longitude: 103.99933,
    timestamp: '2025-02-26T11:34:10Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 17,
    altitude_change: 'C',
    groundspeed: 152,
    heading: 22,
    latitude: 1.37279,
    longitude: 104.00375,
    timestamp: '2025-02-26T11:34:27Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 21,
    altitude_change: 'C',
    groundspeed: 168,
    heading: 21,
    latitude: 1.38354,
    longitude: 104.00785,
    timestamp: '2025-02-26T11:34:43Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 22,
    altitude_change: 'C',
    groundspeed: 194,
    heading: 22,
    latitude: 1.39601,
    longitude: 104.01273,
    timestamp: '2025-02-26T11:34:59Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 25,
    altitude_change: 'C',
    groundspeed: 210,
    heading: 23,
    latitude: 1.41081,
    longitude: 104.01879,
    timestamp: '2025-02-26T11:35:15Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 35,
    altitude_change: 'C',
    groundspeed: 213,
    heading: 25,
    latitude: 1.43292,
    longitude: 104.02864,
    timestamp: '2025-02-26T11:35:40Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 41,
    altitude_change: 'C',
    groundspeed: 239,
    heading: 27,
    latitude: 1.45718,
    longitude: 104.03986,
    timestamp: '2025-02-26T11:36:04Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 45,
    altitude_change: 'C',
    groundspeed: 250,
    heading: 44,
    latitude: 1.47322,
    longitude: 104.05151,
    timestamp: '2025-02-26T11:36:23Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 52,
    altitude_change: 'C',
    groundspeed: 255,
    heading: 69,
    latitude: 1.48506,
    longitude: 104.06937,
    timestamp: '2025-02-26T11:36:41Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 58,
    altitude_change: 'C',
    groundspeed: 257,
    heading: 93,
    latitude: 1.48837,
    longitude: 104.08852,
    timestamp: '2025-02-26T11:36:58Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 65,
    altitude_change: 'C',
    groundspeed: 264,
    heading: 123,
    latitude: 1.48031,
    longitude: 104.11,
    timestamp: '2025-02-26T11:37:16Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 72,
    altitude_change: 'C',
    groundspeed: 269,
    heading: 131,
    latitude: 1.46686,
    longitude: 104.12865,
    timestamp: '2025-02-26T11:37:36Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 79,
    altitude_change: 'C',
    groundspeed: 279,
    heading: 147,
    latitude: 1.44296,
    longitude: 104.14657,
    timestamp: '2025-02-26T11:37:58Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 95,
    altitude_change: 'C',
    groundspeed: 263,
    heading: 148,
    latitude: 1.41272,
    longitude: 104.16521,
    timestamp: '2025-02-26T11:38:28Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 105,
    altitude_change: 'C',
    groundspeed: 271,
    heading: 146,
    latitude: 1.38051,
    longitude: 104.186,
    timestamp: '2025-02-26T11:38:58Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 115,
    altitude_change: 'C',
    groundspeed: 274,
    heading: 146,
    latitude: 1.34894,
    longitude: 104.20707,
    timestamp: '2025-02-26T11:39:28Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 123,
    altitude_change: 'C',
    groundspeed: 281,
    heading: 146,
    latitude: 1.31775,
    longitude: 104.22805,
    timestamp: '2025-02-26T11:39:58Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 128,
    altitude_change: 'C',
    groundspeed: 304,
    heading: 145,
    latitude: 1.2841,
    longitude: 104.25107,
    timestamp: '2025-02-26T11:40:28Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 131,
    altitude_change: 'C',
    groundspeed: 328,
    heading: 145,
    latitude: 1.24802,
    longitude: 104.27607,
    timestamp: '2025-02-26T11:40:58Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 136,
    altitude_change: 'C',
    groundspeed: 346,
    heading: 146,
    latitude: 1.20789,
    longitude: 104.30344,
    timestamp: '2025-02-26T11:41:28Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 141,
    altitude_change: 'C',
    groundspeed: 363,
    heading: 145,
    latitude: 1.16665,
    longitude: 104.33162,
    timestamp: '2025-02-26T11:41:59Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 148,
    altitude_change: 'C',
    groundspeed: 376,
    heading: 145,
    latitude: 1.1247,
    longitude: 104.36065,
    timestamp: '2025-02-26T11:42:29Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 156,
    altitude_change: 'C',
    groundspeed: 377,
    heading: 144,
    latitude: 1.08124,
    longitude: 104.39162,
    timestamp: '2025-02-26T11:42:59Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 163,
    altitude_change: 'C',
    groundspeed: 384,
    heading: 144,
    latitude: 1.03816,
    longitude: 104.42254,
    timestamp: '2025-02-26T11:43:29Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 172,
    altitude_change: 'C',
    groundspeed: 386,
    heading: 144,
    latitude: 0.99589,
    longitude: 104.45322,
    timestamp: '2025-02-26T11:43:59Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 179,
    altitude_change: 'C',
    groundspeed: 391,
    heading: 144,
    latitude: 0.94917,
    longitude: 104.48724,
    timestamp: '2025-02-26T11:44:31Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 186,
    altitude_change: 'C',
    groundspeed: 394,
    heading: 143,
    latitude: 0.90423,
    longitude: 104.52018,
    timestamp: '2025-02-26T11:45:01Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 192,
    altitude_change: 'C',
    groundspeed: 400,
    heading: 143,
    latitude: 0.85954,
    longitude: 104.55339,
    timestamp: '2025-02-26T11:45:31Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 199,
    altitude_change: 'C',
    groundspeed: 404,
    heading: 143,
    latitude: 0.81148,
    longitude: 104.58896,
    timestamp: '2025-02-26T11:46:04Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 205,
    altitude_change: 'C',
    groundspeed: 409,
    heading: 143,
    latitude: 0.76313,
    longitude: 104.62508,
    timestamp: '2025-02-26T11:46:36Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 212,
    altitude_change: 'C',
    groundspeed: 411,
    heading: 143,
    latitude: 0.7156,
    longitude: 104.66078,
    timestamp: '2025-02-26T11:47:07Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 218,
    altitude_change: 'C',
    groundspeed: 413,
    heading: 143,
    latitude: 0.67012,
    longitude: 104.69477,
    timestamp: '2025-02-26T11:47:37Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 224,
    altitude_change: 'C',
    groundspeed: 417,
    heading: 143,
    latitude: 0.6237,
    longitude: 104.7295,
    timestamp: '2025-02-26T11:48:07Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 229,
    altitude_change: 'C',
    groundspeed: 422,
    heading: 143,
    latitude: 0.57688,
    longitude: 104.76458,
    timestamp: '2025-02-26T11:48:37Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 235,
    altitude_change: 'C',
    groundspeed: 425,
    heading: 143,
    latitude: 0.52925,
    longitude: 104.80024,
    timestamp: '2025-02-26T11:49:07Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 240,
    altitude_change: 'C',
    groundspeed: 428,
    heading: 144,
    latitude: 0.48161,
    longitude: 104.83541,
    timestamp: '2025-02-26T11:49:37Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 246,
    altitude_change: 'C',
    groundspeed: 430,
    heading: 144,
    latitude: 0.43364,
    longitude: 104.87065,
    timestamp: '2025-02-26T11:50:07Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 250,
    altitude_change: 'C',
    groundspeed: 436,
    heading: 144,
    latitude: 0.38615,
    longitude: 104.90527,
    timestamp: '2025-02-26T11:50:37Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 256,
    altitude_change: 'C',
    groundspeed: 439,
    heading: 144,
    latitude: 0.33541,
    longitude: 104.94216,
    timestamp: '2025-02-26T11:51:07Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 260,
    altitude_change: 'C',
    groundspeed: 443,
    heading: 144,
    latitude: 0.28592,
    longitude: 104.978,
    timestamp: '2025-02-26T11:51:37Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 264,
    altitude_change: 'C',
    groundspeed: 445,
    heading: 147,
    latitude: 0.24944,
    longitude: 105.00379,
    timestamp: '2025-02-26T11:51:59Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 272,
    altitude_change: 'C',
    groundspeed: 446,
    heading: 156,
    latitude: 0.17441,
    longitude: 105.04093,
    timestamp: '2025-02-26T11:52:40Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 276,
    altitude_change: 'C',
    groundspeed: 452,
    heading: 155,
    latitude: 0.11673,
    longitude: 105.06784,
    timestamp: '2025-02-26T11:53:10Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 281,
    altitude_change: 'C',
    groundspeed: 454,
    heading: 155,
    latitude: 0.05965,
    longitude: 105.0948,
    timestamp: '2025-02-26T11:53:40Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 285,
    altitude_change: 'C',
    groundspeed: 457,
    heading: 155,
    latitude: 0.00228,
    longitude: 105.12183,
    timestamp: '2025-02-26T11:54:10Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 291,
    altitude_change: 'C',
    groundspeed: 459,
    heading: 155,
    latitude: -0.05754,
    longitude: 105.14991,
    timestamp: '2025-02-26T11:54:41Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 295,
    altitude_change: 'C',
    groundspeed: 461,
    heading: 155,
    latitude: -0.11554,
    longitude: 105.1771,
    timestamp: '2025-02-26T11:55:11Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 300,
    altitude_change: 'C',
    groundspeed: 463,
    heading: 155,
    latitude: -0.17257,
    longitude: 105.20385,
    timestamp: '2025-02-26T11:55:41Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 305,
    altitude_change: 'C',
    groundspeed: 466,
    heading: 155,
    latitude: -0.23323,
    longitude: 105.2324,
    timestamp: '2025-02-26T11:56:12Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 309,
    altitude_change: 'C',
    groundspeed: 468,
    heading: 155,
    latitude: -0.29251,
    longitude: 105.26024,
    timestamp: '2025-02-26T11:56:42Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 314,
    altitude_change: 'C',
    groundspeed: 469,
    heading: 155,
    latitude: -0.35165,
    longitude: 105.28808,
    timestamp: '2025-02-26T11:57:12Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 318,
    altitude_change: 'C',
    groundspeed: 473,
    heading: 155,
    latitude: -0.40975,
    longitude: 105.31537,
    timestamp: '2025-02-26T11:57:42Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 321,
    altitude_change: 'C',
    groundspeed: 477,
    heading: 155,
    latitude: -0.46836,
    longitude: 105.34293,
    timestamp: '2025-02-26T11:58:12Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 324,
    altitude_change: 'C',
    groundspeed: 480,
    heading: 155,
    latitude: -0.5306,
    longitude: 105.37219,
    timestamp: '2025-02-26T11:58:42Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 328,
    altitude_change: 'C',
    groundspeed: 482,
    heading: 155,
    latitude: -0.59242,
    longitude: 105.40127,
    timestamp: '2025-02-26T11:59:12Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 332,
    altitude_change: 'C',
    groundspeed: 484,
    heading: 155,
    latitude: -0.65222,
    longitude: 105.42937,
    timestamp: '2025-02-26T11:59:42Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 337,
    altitude_change: 'C',
    groundspeed: 482,
    heading: 155,
    latitude: -0.7143,
    longitude: 105.45852,
    timestamp: '2025-02-26T12:00:12Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 340,
    altitude_change: 'C',
    groundspeed: 483,
    heading: 155,
    latitude: -0.77339,
    longitude: 105.48635,
    timestamp: '2025-02-26T12:00:42Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 344,
    altitude_change: 'C',
    groundspeed: 485,
    heading: 155,
    latitude: -0.83501,
    longitude: 105.51526,
    timestamp: '2025-02-26T12:01:12Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 346,
    altitude_change: 'C',
    groundspeed: 489,
    heading: 155,
    latitude: -0.89757,
    longitude: 105.54471,
    timestamp: '2025-02-26T12:01:42Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 348,
    altitude_change: 'C',
    groundspeed: 492,
    heading: 155,
    latitude: -0.96005,
    longitude: 105.57407,
    timestamp: '2025-02-26T12:02:12Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 352,
    altitude_change: 'C',
    groundspeed: 491,
    heading: 155,
    latitude: -1.0237,
    longitude: 105.60398,
    timestamp: '2025-02-26T12:02:44Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 360,
    altitude_change: 'C',
    groundspeed: 485,
    heading: 156,
    latitude: -1.10059,
    longitude: 105.6398,
    timestamp: '2025-02-26T12:03:20Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 365,
    altitude_change: 'C',
    groundspeed: 483,
    heading: 161,
    latitude: -1.16368,
    longitude: 105.6632,
    timestamp: '2025-02-26T12:03:50Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 368,
    altitude_change: 'C',
    groundspeed: 483,
    heading: 160,
    latitude: -1.22563,
    longitude: 105.68469,
    timestamp: '2025-02-26T12:04:21Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 372,
    altitude_change: 'C',
    groundspeed: 480,
    heading: 159,
    latitude: -1.28954,
    longitude: 105.70818,
    timestamp: '2025-02-26T12:04:51Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 378,
    altitude_change: 'C',
    groundspeed: 473,
    heading: 159,
    latitude: -1.35127,
    longitude: 105.7314,
    timestamp: '2025-02-26T12:05:21Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 382,
    altitude_change: 'C',
    groundspeed: 467,
    heading: 159,
    latitude: -1.41421,
    longitude: 105.75506,
    timestamp: '2025-02-26T12:05:51Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 384,
    altitude_change: 'C',
    groundspeed: 468,
    heading: 159,
    latitude: -1.47693,
    longitude: 105.7786,
    timestamp: '2025-02-26T12:06:22Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 386,
    altitude_change: 'C',
    groundspeed: 469,
    heading: 159,
    latitude: -1.53955,
    longitude: 105.80211,
    timestamp: '2025-02-26T12:06:53Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 390,
    altitude_change: 'C',
    groundspeed: 466,
    heading: 159,
    latitude: -1.59902,
    longitude: 105.82443,
    timestamp: '2025-02-26T12:07:23Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 390,
    altitude_change: 'C',
    groundspeed: 468,
    heading: 159,
    latitude: -1.66278,
    longitude: 105.84834,
    timestamp: '2025-02-26T12:07:54Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 390,
    altitude_change: '-',
    groundspeed: 472,
    heading: 159,
    latitude: -1.75337,
    longitude: 105.88237,
    timestamp: '2025-02-26T12:08:39Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 390,
    altitude_change: '-',
    groundspeed: 477,
    heading: 159,
    latitude: -2.38008,
    longitude: 106.11765,
    timestamp: '2025-02-26T12:13:43Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 390,
    altitude_change: '-',
    groundspeed: 479,
    heading: 159,
    latitude: -2.44354,
    longitude: 106.14143,
    timestamp: '2025-02-26T12:14:14Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 390,
    altitude_change: '-',
    groundspeed: 480,
    heading: 159,
    latitude: -2.56842,
    longitude: 106.18835,
    timestamp: '2025-02-26T12:15:14Z',
    update_type: 'A'
  },
  {
    fa_flight_id: null,
    altitude: 390,
    altitude_change: '-',
    groundspeed: 485,
    heading: 159,
    latitude: -2.68185,
    longitude: 106.231,
    timestamp: '2025-02-26T12:16:08Z',
    update_type: 'A'
  }
];
